import React, { useEffect } from "react";
import {ShowableProductCard} from "ReactApp/Ddd/Aggregates/ShowableProductCard";
import {observer} from "mobx-react";

type AddToCompareV2Props = {
    productCard: ShowableProductCard
}

const AddToCompareV2 = observer((props: AddToCompareV2Props) => {

    const { currentProductConfig } =  props.productCard;
    if (!currentProductConfig) {
        return <div>Загрузка...</div>;
    }
    let uniqueKey = currentProductConfig.getUniqueId();

    useEffect(() => {
        window?.widgets?.addToCompareV1?.checkSelected();
    }, [uniqueKey]);

    return (
        <a className="link-with-icon-v1 add-to-compare-v1 link-with-icon-v1_text-color-type-main link-with-icon-v1_decoration-type-none"
           key={uniqueKey}
           href="#" add-to-compare-v1=""
           data-add-to-compare-v1-is-in-compare="0"
           data-add-to-compare-v1-product-type-id={currentProductConfig.productTypeId}
           data-add-to-compare-v1-id={currentProductConfig.id}
           data-add-to-compare-v1-virtual-modifier-id={currentProductConfig.virtualModifierId ?? ""}
        >
            <svg className="icon-v1 link-with-icon-v1__icon" width="20" height="20">
                <use xlinkHref="/build/sprite.svg#equalizer-iconV2"></use>
            </svg>
            <div className="link-with-icon-v1__label">Сравнить</div>
        </a>
    );
});

export { AddToCompareV2 };